import Thunk from './';
import { Data, List } from 'src/interfaces/general';
import homeworkCommentActions from 'src/store/model/homework_comment';
import userAssignmentFileActions from 'src/store/model/user_assignment_file';

const homework_comments = new Thunk('homework_comments');

export type HomeworkCommentPayload = Partial<Model.HomeworkComment>;

export const fetchHomeworkComments = homework_comments.fetch<
  List<Model.HomeworkComment>,
  SearchParams.HomeworkComment
>({
  onSuccess({ data, dispatch, args }) {
    dispatch(homeworkCommentActions.updateEntities(data.data));
    dispatch(
      homeworkCommentActions.updatePagination({
        pagination: data.paginator,
        user_assignment_file_id: args.user_assignment_file_id,
      }),
    );
  },
});

export const fetchHomeworkCommentDetail = homework_comments.fetchOne<
  Data<Model.HomeworkComment>
>({
  onSuccess({ data, dispatch }) {
    // only for parent
    if (!data.data.parent_id) {
      dispatch(homeworkCommentActions.updateEntity(data.data));
    }
  },
});

export const createHomeworkComment = homework_comments.create<
  Data<Model.HomeworkComment>,
  HomeworkCommentPayload
>({
  onSuccess({ data, dispatch }) {
    dispatch(homeworkCommentActions.updateEntity(data.data));
    dispatch(userAssignmentFileActions.increaseNumberOfComments(data.data));
  },
});

export const updateHomeworkComment = homework_comments.update<
  Data<Model.HomeworkComment>,
  HomeworkCommentPayload
>({
  onSuccess({ data, dispatch }) {
    dispatch(homeworkCommentActions.updateEntity(data.data));
  },
});

export const deleteHomeworkComment = homework_comments.remove({
  onSuccess({ args, dispatch }) {
    dispatch(homeworkCommentActions.removeEntity(args));
    dispatch(userAssignmentFileActions.decreaseNumberOfComments(args));
  },
});
